import React from 'react';
import img from './packages/components/assets/images/avatar.svg.js';

function getSizeCss(size) {
    switch (size) {
        case 'small':
            return 'w-6 h-6';
        case 'large':
            return 'w-12 h-12';
        case 'xlarge':
            return 'w-20 h-20';
        default:
            return 'w-8 h-8';
    }
}
const Avatar = ({ border = false, className = '', image, label = '', size = 'medium', width, height, Component = 'img', ...props }) => {
    return (React.createElement("figure", { className: [
            'overflow-hidden rounded-full bg-green',
            border ? 'border-2 border-green' : '',
            getSizeCss(size),
            className,
        ].join(' '), ...props },
        React.createElement(Component, { src: image || img, alt: label, className: "w-full h-full object-cover", loading: "lazy", width: width ? width : '100%', height: height ? height : '100%' })));
};

export { Avatar };
//# sourceMappingURL=Avatar.js.map
